export { default } from "./DispensaryUpdate";
